












import { computed, defineComponent, onMounted, PropType, ref } from "@vue/composition-api";
import { VipStatus } from "@scrile/api-provider/dist/api/UserProvider";
import { UserWithAvatar } from "@scrile/api-provider/dist/api/UserPublicDataProvider";
import { resolveUserName } from "@/lib/userHelpers";
import BaseIcon from "@/components/BaseIcon";

export default defineComponent({
  name: "ScreenNamePrinter",
  components: { BaseIcon },
  props: {
    user: { type: Object as PropType<UserWithAvatar> },
    inline: { type: Boolean, default: false },
    truncate: { type: Boolean, default: false },
    resolve: { type: Boolean, default: false },
  },
  setup(props) {
    const el = ref<HTMLElement>();
    const iconSize = ref<string | number>(16);

    const isVip = computed(() => (props.user?.vipStatus ? props.user.vipStatus !== VipStatus.DEFAULT : false));
    const screenName = computed(() => (props.resolve ? resolveUserName(props.user) : props.user?.screenName ?? ""));

    onMounted(() => {
      if (!el.value) return;
      iconSize.value = window.getComputedStyle(el.value).lineHeight;
    });
    return {
      el,
      iconSize,
      isVip,
      screenName,
      VipStatus,
    };
  },
});
